import PasswordResetSent from "./PasswordResetSent";

export default PasswordResetSent;